/** 与 orderModel.deliveryStatus、列表列展示口径一致（3 段） */

import { normalizeStoredDeliveryStatus } from './orderDeliveryStatus.js';

import { ORDER_DELIVERY_STATUS_LABELS } from './orderStatus.js';

export const getOrderDeliveryStatusLabel = (status) => ORDER_DELIVERY_STATUS_LABELS[normalizeStoredDeliveryStatus(status)] ?? status ?? '-';

/** @returns {{ bg: string, icon: string, text: string, pill: boolean | string }} */
export const getOrderDeliveryStatusBadgeProps = (deliveryStatus, order = null) => {
	const canonical = normalizeStoredDeliveryStatus(deliveryStatus, order);
	switch (canonical) {
		case 'waitingDelivery':
			return { bg: 'danger', icon: 'stream', text: '待发货', pill: false };
		case 'waitingAccept':
			return { bg: 'danger', icon: 'stream', text: '待验收', pill: false };
		case 'logisticsComplete':
			return { bg: 'success', icon: 'check', text: '物流完成', pill: true };
		default:
			return {
				bg: 'secondary',
				icon: 'stream',
				text: getOrderDeliveryStatusLabel(deliveryStatus),
				pill: false,
			};
	}
};
